import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedPosts } from "./relatedPostsAPI";

const initialState = {
  relatedPosts: [],
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchRelatedPosts = createAsyncThunk("relatedPosts/fetchRelatedPosts", async ({id, tags}) => {
  const result = await getRelatedPosts({id, tags});

  return result;
});

const relatedPostsSlice = createSlice({
  name: "relatedPosts",
  initialState,
  extraReducers: (Builder) => {
    Builder.addCase(fetchRelatedPosts.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    })
      .addCase(fetchRelatedPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.relatedPosts = action.payload;
      })
      .addCase(fetchRelatedPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.relatedPosts = [];
      });
  },
});

export default relatedPostsSlice.reducer;
